/**
 * decode-html-entities
 *
 * Decode HTML entities in strings so they never show as literal &apos; etc. in UI.
 * Used for trending search terms, RSS titles, and any external text.
 *
 * Primary responsibilities:
 * - Decode named entities (&apos;, &quot;, &amp;, &lt;, &gt;)
 * - Decode numeric entities (&#39;, &#x27;, etc.)
 * - Safe for server and client (no DOM)
 */

const NAMED_ENTITIES: Record<string, string> = {
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&#x27;': "'",
  '&#x2F;': '/',
  '&#x2f;': '/'
}

/**
 * Decode HTML entities in a string. Idempotent and safe for any input.
 * Ensures text like "men&apos;s" displays as "men's".
 */
export function decodeHtmlEntities(s: string): string {
  if (!s || typeof s !== 'string') return s
  let out = s
  for (const [ent, char] of Object.entries(NAMED_ENTITIES)) {
    out = out.replace(new RegExp(ent, 'gi'), char)
  }
  out = out.replace(/&#(\d+);/g, (_, n) => {
    const code = parseInt(n, 10)
    return code >= 0 && code <= 0x10ffff ? String.fromCharCode(code) : `&#${n};`
  })
  out = out.replace(/&#x([0-9a-f]+);/gi, (_, hex) => {
    const code = parseInt(hex, 16)
    return code >= 0 && code <= 0x10ffff ? String.fromCharCode(code) : `&#x${hex};`
  })
  return out
}
